import { Plus, Trash2 } from "lucide-react";

import { useTran } from "@/hooks";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { InputField } from "@/components/common";

const SurveyQuestionOptionsEditor = ({
  options,
  pointsEnabled,
  requirePoints,
  isEditable,
  onAddOption,
  onOptionLabelChange,
  onOptionPointsChange,
  onRemoveOption,
}) => {
  const { t } = useTran();

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
            {t("Options")}
          </p>
          <p className="text-[11px] text-muted-foreground">
            {t("Define answer choices and scoring.")}
          </p>
        </div>
        {isEditable ? (
          <Button
            type="button"
            size="sm"
            onClick={onAddOption}
            variant="secondary"
            className="rounded-full"
          >
            <Plus className="mr-1 h-4 w-4" />
            {t("Add Option")}
          </Button>
        ) : null}
      </div>

      {isEditable ? (
        <div className="space-y-2">
          {(options || []).map((option, index) => (
            <div
              key={option.id ?? index}
              className="grid gap-3 rounded-radius border border-border bg-muted/40 p-3 md:grid-cols-5"
            >
              <InputField
                label={t("Option")}
                labelClassName="text-[11px] font-semibold uppercase tracking-wide text-muted-foreground"
                value={option.label}
                onChange={(event) =>
                  onOptionLabelChange(index, event.target.value)
                }
                className="space-y-1 md:col-span-3"
              />
              {pointsEnabled && requirePoints ? (
                <InputField
                  label={t("Points")}
                  labelClassName="text-[11px] font-semibold uppercase tracking-wide text-muted-foreground"
                  type="number"
                  min="1"
                  max="5"
                  value={option.points ?? 1}
                  onChange={(event) =>
                    onOptionPointsChange(index, event.target.value)
                  }
                  className="space-y-1"
                />
              ) : null}
              <div className="flex items-end justify-end">
                <Button
                  type="button"
                  size="icon"
                  variant="destructive"
                  onClick={() => onRemoveOption(index)}
                >
                  <Trash2 className="h-4 w-4" />
                </Button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-xs text-muted-foreground">
          {t("Options are fixed for this question type.")}
        </p>
      )}
    </div>
  );
};

export default SurveyQuestionOptionsEditor;
